import Dashboard from "../dashboard/Dashboard";
import Button from "../../components/buttons/Button";
import "../../components/generalComponents.scss";
import style from "../reviews/review.module.scss";
import adminStyle from "./admin.module.scss";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getDetails, updateData } from "../../services/review.service";
import { ActionType } from "../../utils/constants";
import showToast from "../../utils/show.toast";
import formatDate from "../../utils/date.formater";
import {
  Admin,
  adminDetails,
  adminStatus,
  AdminStatusType,
} from "../../services/admin.service";
import AdminStatusButtons from "./component/status.button";

interface IDetails {
  // isLoading: boolean,
  details: Admin;
}

// function useQuery() {
//   return new URLSearchParams(useLocation().search);
// }

interface AdminData {
  firstName: string;
  lastName: string;
  email: string;
  dateOfBirth: string;
  status: AdminStatusType;
}

export default function ShowAdminDetailsPage() {
  const router = useNavigate();

  const { requestId } = useParams();
  const [adminData, setAdminData] = useState<AdminData>({
    firstName: "",
    lastName: "",
    email: "",
    dateOfBirth: "",
    status: AdminStatusType.ACTIVE,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!requestId) return;

        const data = await adminDetails(Number(requestId));
        if (data.status !== "success") {
          return showToast("Error occured fetching datas!", false);
        }
        setAdminData(data.result);
      } catch (error) {
        return showToast("There is an error fetching admin details!", false);
      }
    };
    fetchData();
  }, [requestId]);

  const handleStatusUpdate = async (status: AdminStatusType) => {
    try {
      const req = await adminStatus(status);
      if (req.status !== "success") {
        return showToast(
          `Admin was not ${status.toLocaleLowerCase()} successfully!`,
          false
        );
      }
      showToast(`Admin was  ${status.toLocaleLowerCase()} successfully!`, true);
    } catch (error) {
      return showToast("An error occured performing this action!", false);
    }
  };

  return (
    <Dashboard>
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex" }}>
            <FontAwesomeIcon
              icon={faArrowLeftLong}
              onClick={() => router(-1)}
              style={{
                marginTop: "1px",
                marginRight: "0.7rem",
                cursor: "pointer",
              }}
            />
            <h5 style={{ marginRight: "4rem" }}>Administrator Details</h5>
          </div>
          <div className="">
            <AdminStatusButtons
              status={adminData.status}
              adminStatusUpdate={handleStatusUpdate}
            />
          </div>
        </div>
        <div className="section">
          <div>
            <input
              type="radio"
              name="option"
              value="1"
              checked
              className={adminStyle.radioBtn}
            />
            <p className={adminStyle.textStyle}>Admin Credentials</p>
          </div>

          <div className={style.textWrapper}>
            <h5> Email</h5>
            <p className={style.textStyle}>{adminData?.email}</p>
          </div>

          <hr
            style={{
              marginTop: "1rem",
              marginBottom: "2rem",
              fontWeight: "lighter",
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <button className={adminStyle.createButton}>
                {" "}
                Copy Credential
              </button>

              <p
                style={{
                  color: " rgb(55, 134, 170)",
                  fontSize: "18px",
                  margin: "0.8rem",
                  fontWeight: "bolder",
                  cursor: "pointer",
                  textDecoration: "line",
                }}
              >
                Update Credential
              </p>
            </div>

            <p
              style={{
                color: "red",
                fontSize: "18px",
                fontWeight: "bolder",
                cursor: "pointer",
              }}
            >
              Delete
            </p>
          </div>
        </div>
      </>
    </Dashboard>
  );
}
